import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, } from 'react';
import { cn, tw } from '../../utils/classnames.js';
const sizeStyles = {
    // TODO: Add more sizes as they are needed.
    10: tw `ui-text-[0.625rem]`,
    11: tw `ui-text-[0.6875rem] ui-leading-[0.8125rem]`,
    12: tw `ui-text-xs`,
    13: tw `ui-text-[0.8125rem] ui-leading-[1.125rem]`,
    14: tw `ui-text-sm`,
    16: tw `ui-text-base`,
    18: tw `ui-text-lg`,
    21: tw `ui-text-[1.3125rem] ui-leading-[1.4375rem]`,
    24: tw `ui-text-2xl`,
    32: tw `ui-text-[2rem] ui-leading-[2.375rem]`,
    40: tw `ui-text-[2.5rem] ui-leading-[3rem]`,
    54: tw `ui-text-[3.375rem] ui-leading-[3.375rem]`,
};
const alignStyles = {
    left: tw `ui-text-left`,
    center: tw `ui-text-center`,
    right: tw `ui-text-right`,
};
function Text({ children, className, style, align = 'left', as: Component = 'p', monospace = false, size = 16, uppercase = false, dataTestId, }, ref) {
    return (_jsx(Component, { ref: ref, className: cn('ui-font-medium ui-text-black theme-dark:ui-text-white', monospace ? 'ui-font-mono' : 'ui-font-sans', uppercase && 'ui-uppercase', sizeStyles[size], alignStyles[align], className), style: style, "data-testid": dataTestId, children: children }));
}
export default forwardRef(Text);
